import {Timeline, TimelineEvent} from 'react-event-timeline'
import React, { Component, PropTypes } from 'react';
import classnames from 'classnames'
import Loading from 'components/UI/Loading'
import moment from 'moment'
import locale from './locale'
import './Timeline.scss'
import {confirm} from 'util/confirm'
import {alert} from 'util/alert'
import __R, { userCan } from 'containers/__R'

class ReactTimeline extends Component {

  static propTypes = {
    tasks: PropTypes.array,
  }

  constructor(props) {
    super(props);

    this.state = {
      showDetail: {},
    }

    this.updateTask = this.updateTask.bind(this)
  }

  updateTask(key, task, type){
    return (e)=>{
      e.stopPropagation();

      if(task.state == 0){

        let newTask = {
          ...task,
          state: 1,
          due_datetime: task.due_datetime ? moment(task.due_datetime).format('YYYY-MM-DD HH:mm') : undefined,
          remind_at: task.remind_at ? moment(task.remind_at).format('YYYY-MM-DD HH:mm') : undefined,
        }

        delete newTask.teacher_id_assigned_to
        delete newTask.teacher_name_assigned_to
        delete newTask.id

        this.props.updateTask(key, task.id, newTask, type)
      } else if (task.state == 1){

        let newTask = {
          ...task,
          state: 0,
          due_datetime: task.due_datetime ? moment(task.due_datetime).format('YYYY-MM-DD HH:mm') : undefined,
          remind_at: task.remind_at ? moment(task.remind_at).format('YYYY-MM-DD HH:mm') : undefined,
        }

        delete newTask.teacher_id_assigned_to
        delete newTask.teacher_name_assigned_to
        delete newTask.id

        this.props.updateTask(key, task.id, newTask, type)
      }
    }
  }

  render() {
    const {tasks, showTimeline, type, editTask, deleteTask, fetching} = this.props
    const {showDetail} = this.state;

    if(showTimeline == false){
      return (<div />)
    }

    return (
      <div className={classnames('react-timeline-container', {fetching})}>
        { fetching && <Loading /> }
        <Timeline className='Timeline' lineColor='#EBEBED' lineStyle={{ width: 1 }} >
          {tasks.map((task, key) => {
            return(
              <div key={key}>
                <TimelineEvent
                  className='timeline-event-container'
                  title={''}
                  contentStyle={{boxShadow: 'none', padding: '0px'}}
                  bubbleStyle={{background: 'none', color: 'white', fontSize: '15px', border: 'none'}}
                  titleStyle={{color: '#11151E', fontSize: '20px', fontWeight: '600'}}
                  createdAt={<div className='createdAt'>{moment(task.due_datetime).format('YYYY-MM-DD')}</div>}
                  icon={<img className='school-success-icon' src={task.state == 1 ? require('data/images/Group@2x.png') : require('data/images/grey@2x.png')} />}
                >
                  {showDetail[task.id] !== true && <div className='task-container'>
                    <div className='col-xs-12 short-task' onClick={() => {
                      this.setState({showDetail: {
                        ...this.state.showDetail,
                        [task.id]: true
                      }})
                    }}>
                      <span className='timeline-title'>{task.title}</span>
                      <i className='fa icon-angle-down pull-right'></i>
                    </div>
                  </div>}
                  {showDetail[task.id] && <div className='task-container detail-task' onClick={() => {
                    this.setState({showDetail: {
                      ...this.state.showDetail,
                      [task.id]: false,
                    }})
                  }}>
                    <span className='timeline-title'>{task.title}</span>
                    <i className='fa icon-angle-up pull-right'></i>
                    <div className='event-date-info'>
                      { task.teacher_name_assigned_to && <span style={{marginRight: '50px'}}>{__('Person In Charge: {name}', locale, {name: task.teacher_name_assigned_to})}</span> }
                      { task.remind_at && <span>{__('Reminder Time: {time}', locale, {time: moment(task.remind_at).format('YYYY-MM-DD HH:mm')})}</span> }
                    </div>
                    { task.note && <div className='timeline-content'>{task.note}</div> }
                    <div className=''>
                      <div className='btn-container'>
                        {task.state == 1 && <__R can='complete_student_task' by='disable'>
                          <button className='btn btn-default btn-sm' onClick={
                            this.updateTask(key, task, type)
                          }>{__('Completed', locale)}</button>
                        </__R>}
                        {task.state == 0 && <__R can='complete_student_task' by='disable'>
                          <button className='btn btn-primary btn-sm' onClick={
                            this.updateTask(key, task, type)
                          }>{__('Complete', locale)}</button>
                        </__R>}
                        <__R can='edit_student_task' by='disable'>
                          <button className='btn-link edit-event' onClick={(e)=>{
                            e.stopPropagation();
                            editTask(task, key);
                          }}>{__('Edit', locale)}</button>
                        </__R>
                        <__R can='delete_student_task' by='disable'>
                          <button className='btn-link delete-event' onClick={(e) => {
                            e.stopPropagation();
                            confirm(__('Proceed to delete task?', locale))
                            .then(() => {deleteTask(key, task.id)})
                            .catch(() => {})
                          }}>{__('Delete', locale)}</button>
                        </__R>
                      </div>
                    </div>
                  </div>}
                </TimelineEvent>
              </div>
            )
          })}
        </Timeline>
      </div>
    );
  }
}

export default ReactTimeline;



// WEBPACK FOOTER //
// ./src/components/UI/ReactTimeline/index.js